export const styles = {
  container: {
    position: "sticky",
    top: "10px",
    minWidth: "300px",
    padding: "24px 16px",
    borderRadius: "8px",
    border: "1px solid #E7E7E7",
    background: "var(--Gray-White, #FFF)",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    height: "fit-content",
  },
  headerContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  priceContainer: {
    display: "flex",
    alignItems: "flex-end",
  },
  price: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
  },
  type: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "25px",
  },
  expiresIn: {
    color: "var(--Error-500, #E34444)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  divider: {
    mx: "-24px",
  },
  serviceDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  serviceDetailsTitle: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  serviceDetailsValue: {
    color: "var(--Gray-600, #6E7485)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  serviceDetailsChip: {
    color: "var(--Green---100, #008B07)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 12px",
    borderRadius: "16px",
    background: "var(--Green---25, #E7EFED)",
    maxWidth: "60px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
  userInfoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  avatarContainer: {
    position: "relative",
  },
  avatar: {
    width: "44px",
    height: "44px",
  },
  verifiedIcon: {
    position: "absolute",
    bottom: "-6px",
    left: "22px",
    transform: "translateX(-50%)",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  userName: {
    textDecoration: "none",
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  userRole: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
  },
  providerDetailsTitle: {
    fontFamily: "Montserrat",
    color: "#707070",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  shareContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  shareTitle: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  shareButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  shareButton: {
    padding: "12px",
    borderRadius: "6px",
    background: "var(--Green---25, #E7EFED) !important",
  },
  removeServiceButton: {
    backgroundColor: "#FFF",
    color: "var(--Red---200, #CC3E3E)",
    border: "1px solid var(--Red---200, #CC3E3E)",
  },
} as const;
